<template>
  <modal
    name="covve-ad-modal"
    classes="v--modal-covve-ad"
    height="auto"
    adaptive
  >
    <div class="modal-header">
      <div class="header">
        Tired of your old address book?
        <p class="close-button">
          <button @click="$modal.hide('covve-ad-modal')">
            <i class="fas fa-times"></i>
          </button>
        </p>
      </div>
    </div>

    <div class="modal-content">
      <div class="modal-title">
        Do your contacts still look like they did in the 80’s? Switch to a smart
        address book now!
      </div>

      <div class="share-box">
        <p class="title">Get Covve!</p>
        <p class="caption">
          Covve is the simplest, smartest address book app. It is also free :)
        </p>
      </div>

      <p style="text-align:center;margin-top: 20px">
        <a class="img-a-button" href="https://covve.com/" target="_blank">
          <img src="@/assets/btn-download.png" alt="Save" />
        </a>
      </p>

      <!-- <p style="text-align:center;font-size:0.525rem">
        <a class="img-a-button" @click="$modal.hide('covve-ad-modal')">
          No, I want to keep my old address book!
        </a>
      </p> -->
    </div>
  </modal>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.share-box {
  text-align: center;
  padding: 25px 15px;
  .title {
    color: #ec008b;
  }
  .caption {
    margin-top: 10px;
    font-size: 0.625rem;
  }
  a {
    margin: 0 5px;
  }
  background: #312a58;
  border-radius: 20px;
}
</style>
